<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <div class="card p-1 mt-3 mb-3 w-75 mx-auto border-danger">
      <p class="p-1">
        <br>
        {{ instruction5 }} <strong><i>indispensable</i></strong> que exista su <strong><i>grupo de formas
            asociado.</i></strong>
        <br> {{ instruction6 }}<router-link class="link1" to="/Admin/ListImgFormFamilies">Grupos de
          formas</router-link>
        {{ instruction7 }}{{ instruction4 }}
      </p>
    </div>
    <div class="mt-4 mb-3 me-5 float-end">
      <button class="btn btn-danger">
        <router-link class="link2" to="/Admin/ProfileNewImg">Añadir nueva forma</router-link>
      </button>
    </div>
    <h4 class="mt-4 mb-3">
      Guía de formas para la línea
      <strong><i> perfiles metálicos </i></strong>
    </h4>
    <EditImgForm v-show="showEditForm" :sendImageId="imageId" @hideEditForm="hideEditForm"></EditImgForm>
    <ImagesCatalogue class="mt-5" @sendImageId="getImageId"></ImagesCatalogue>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ImagesCatalogue from "@/components/Admin/Profile/ProfileImageCatalogueComponent.vue";
import EditImgForm from "@/components/Admin/Profile/EditImgProfileFormComponent.vue";
export default {
  components: {
    NavBarAdmin,
    FooterAdmin,
    ImagesCatalogue,
    EditImgForm,
  },
  data() {
    return {
      showEditForm: false,
      imageId: null,
      instruction5:
        "Tenga en cuenta que antes de de crear cualquier forma es ",
      instruction6:
        "Revise la sección ",
      instruction7: ", sí ninguno obedece a sus necesidades cree uno nuevo.",
      instruction4:
        "En caso de que ya exista el grupo de formas que necesita, haga caso omiso a la instruccón anterior.",
    }
  },
  methods: {
    getImageId(data) {
      // console.log(data);
      this.imageId = data;
      // console.log(this.imageId);
      this.showEditForm = true;
    },
    hideEditForm(data) {
      this.showEditForm = data;
      this.imageId = null;
    },
  }
};
</script>
<style scoped>
.link1 {
  color: #9d0e15;
}
</style>